import moment from "moment";

/* The Manage Payslips CSV download, built from `/api/payslip-export` rows.
   Pure functions: the view fetches and saves, this only turns rows into text,
   so the file layout is pinned by payslipExport.test.js. */

const monthName = (month) => moment.monthsShort()[Number(month) - 1] ?? "";

// a cell opening with one of these runs as a formula in Excel / Sheets
const FORMULA_START = /^[=+\-@\t\r]/;

const csvCell = (value) => {
  let text = value === null || value === undefined ? "" : String(value);
  if (FORMULA_START.test(text) && !/^-?\d+(\.\d+)?$/.test(text)) {
    text = "'" + text;
  }
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCsv = (rows) =>
  rows.map((row) => row.map(csvCell).join(",")).join("\r\n") + "\r\n";

const CSV_COLUMNS = [
  ["Name", (p) => p.name],
  ["Email", (p) => p.email],
  ["Department", (p) => p.department],
  ["Month", (p) => monthName(p.month)],
  ["Year", (p) => p.year],
  ["Working Days", (p) => p.total_working_days],
  ["Total Leaves", (p) => p.total_leaves],
  ["Paid Leaves", (p) => p.paid_leaves],
  ["Actual Salary", (p) => p.actual_salary],
  ["Deduction (%)", (p) => p.deduction_percentage],
  ["Tax", (p) => p.tax_percentage],
  ["PF", (p) => p.pf],
  ["ESI", (p) => p.emp_state_insurance],
  ["Leave Deduction", (p) => p.leave_deduction],
  ["In-hand Salary", (p) => p.in_hand_salary],
  ["Salary Credit", (p) => p.credited_salary],
  ["Visibility", (p) => p.visibility],
  ["Bank Name", (p) => p.bank_name],
  ["Account Number", (p) => p.bank_acc_number],
  ["IFSC", (p) => p.ifsc_code],
];

export const payslipCsv = (payslips) =>
  toCsv([
    CSV_COLUMNS.map(([header]) => header),
    ...payslips.map((p) => CSV_COLUMNS.map(([, read]) => read(p))),
  ]);

/** File name stem for the active Month / Year filters: "2026-10", "2026", "all". */
export const exportPeriod = (month, year) => {
  if (year && month) return `${year}-${String(month).padStart(2, "0")}`;
  if (year) return String(year);
  if (month) return monthName(month).toLowerCase();
  return "all";
};
